<template>
  <div class="bg-slate-50 text-slate-900  dark:bg-slate-950 dark:text-white">
    <router-view />
  </div>
</template>

<script>
import "@/assets/css/style.css";

export default {
};
</script>